import { styled } from '@mui/material';

export const LoaderWrapper = styled('div')<{ forDetail: boolean }>(({ forDetail }) => ({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: forDetail ? 'none' : 'auto',
  zIndex: 99999,
}));
